<template>
  <div>
    <FiltroRapido
      ref="filtroRapido"
      titulo="Locais"
      titulo-filtro="Nome local"
      :enviando="enviando"
      :novo="{
        toRoute: 'LocalNovo',
        routeBack: 'LocalIndex',
      }"
      :pode-criar="isAdmin()"
      @onSubmit="handleSubmit"
    />
    <skeleton-card-list :show="!locais" :number-of-itens="8" />
    <div class="row">
      <div v-for="local in locais" :key="local.id" class="col-md-3 col-6 pb-3">
        <md-card
          class="m-0 mobile-size-100"
          md-with-hover
          @click.native="() => pushRouteLocal(local.id)"
        >
          <div class="card-content">
            <md-card-header>
              <div class="md-title">
                {{ local.nome }}
              </div>
              <div class="md-subhead">
                {{ local.descricao }}
              </div>
            </md-card-header>
          </div>
          <md-divider class="md-small-hide" />
          <md-card-actions class="md-small-hide">
            <div>
              <md-button v-if="local.id === deletandoId">
                <md-progress-spinner
                  class="md-accent"
                  md-mode="indeterminate"
                  :md-diameter="25"
                  :md-stroke="3"
                />
              </md-button>
              <md-dialog-confirm
                :md-active.sync="active"
                md-title="Tem certeza?"
                md-content="Deletar um local é uma ação irreversível. Após concluída os dados do local não poderão ser recuperados"
                md-confirm-text="deletar"
                md-cancel-text="cancelar"
                @md-confirm="excluir(idParaDeletar)"
              />
              <md-button
                v-if="isAdmin() && local.id !== deletandoId"
                class="md-accent"
                @click.stop="() => abrirExcluir(local.id)"
              >
                Excluir
              </md-button>
              <md-button
                v-if="isAdmin()"
                @click.stop="() => pushRouteEditar(local.id)"
              >
                Editar
              </md-button>
            </div>
          </md-card-actions>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import FiltroRapido from '../../components/FiltroRapido'
import SkeletonCardList from '../../components/SkeletonCardList'
import auth from '../../utils/auth'
import http from '../../utils/http'

export default {
  name: 'LocalIndex',
  components: { SkeletonCardList, FiltroRapido },
  data() {
    return {
      locais: undefined,
      enviando: false,
      deletandoId: null,
      idParaDeletar: null,
      active: false,
    }
  },
  async mounted() {
    await this.buscarLocais()
    if (this.locais.length === 1) {
      await this.$router.push({
        name: 'DashboardIndex',
        params: { localId: this.locais[0].id },
      })
    }
  },
  methods: {
    async abrirExcluir(id) {
      this.active = true
      this.idParaDeletar = id
    },
    async excluir(id) {
      this.deletandoId = id
      await http.delete('local', id)
      this.deletandoId = null
      this.idParaDeletar = null
      await this.buscarLocais()
    },
    async handleSubmit(filtro) {
      this.locais = undefined
      this.locais = (
        await http.get('local', {
          filtro,
        })
      ).locais
    },
    isAdmin() {
      return auth.isAdmin()
    },
    pushRouteLocal(id) {
      this.$router.push({
        name: 'DashboardIndex',
        params: { localId: id },
      })
    },
    pushRouteEditar(id) {
      this.$router.push({
        name: 'LocalEditar',
        params: { localId: id },
      })
    },
    async buscarLocais() {
      this.locais = (await http.get('local')).locais
    },
  },
}
</script>

<style lang="scss" scoped>
// Mobile
@media (max-width: 768px) {
  .mobile-size-100 {
    height: 100%;
  }
}

.left-zero {
  padding-left: 0;
  margin-left: 0;
  margin-right: 5% !important;
}

$delay-hover: 300ms;

.local-submenu {
  padding: 2% 2% 2% 4%;
  transition-duration: $delay-hover - 200ms;

  &:hover {
    transition-duration: $delay-hover;
    background-color: #7e53a2;
  }

  &:hover > .local-submenu_text {
    transition-duration: $delay-hover;
    color: white;
  }

  &:hover > i {
    transition-duration: $delay-hover;
    color: white;
  }
}

.local-submenu_text {
  font-size: 1rem;
  padding-left: 3%;
}

.card-content {
  height: 80%;
}
</style>
